import axios from 'axios';
import { MessageWithIcon } from '../components/common/messagePopup';

export const TOKEN = 'token';
export const USER_TYPE = 'user_type';
export const USER_ID = 'user_id';

axios.defaults.baseURL = 'https://thealgohopper.com/dms/api/';

const api = axios.create({
  baseURL: 'https://thealgohopper.com/dms/api/',
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true, // if cookies involved
});

// 🔐 Request Interceptor (to attach token)
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem(TOKEN);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// ❌ Response Interceptor (to handle HTTP errors)
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const code = error.code || '';
    if (code == 'ERR_NETWORK') {
      MessageWithIcon('Network error. Please check your connection.', 'error');
      error.response = {
        status: 500,
        data: { message: 'Network error. Please check your connection.' },
      };
      return Promise.reject(error.response);
    }
    const { status } = error.response || {};

    switch (status) {
      case 400:
        MessageWithIcon(error.message, 'error');
        break;
      case 401:
        // Clear token and redirect to login
        localStorage.removeItem(TOKEN);
        if (error.response.config.url !== 'login/') {
          window.location.href = '/'; // or use navigate from react-router
        }
        MessageWithIcon('Unauthorized. Please login again.', 'error');
        break;
      case 403:
        MessageWithIcon('Forbidden access.', 'error');
        break;
      case 404:
        MessageWithIcon('API not found.', 'error');
        break;
      case 500:
        MessageWithIcon('Server error. Try again later.', 'error');
        break;
      default:
        MessageWithIcon('Unexpected error occurred.', 'error');
        break;
    }

    return Promise.reject(error.response);
  }
);
//axios.defaults.withCredentials = true; // Optional, if using cookies/auth

export default api;
